export enum QuestStatus {
  NOTSTARTED = "NOTSTARTED",
  INPROGRESS = "INPROGRESS",
  FINISHED = "FINISHED",
  ANSWERREVIEWED = "ANSWERREVIEWED",
}
